<template>
  <div class="body-box">
    <!-- 车牌 -->
    <div class="div-public card">
      <input class="firm-clickable"
        v-for="(item, index) in value"
        :key="index"
        type="text"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        @click="handelReveal(index)"
        v-model="item.val"
        @keyup.enter="keyDown"
        @blur="handelFocalPoint"
        id="noDelInput"
        maxlength="1"
        :style="
          value[index].val != '' ? 'background: rgba(97,144,232,0.27);' : ''
        "
      />

      <div
        class="card-window"
        :style="cardShowHide == '1' ? 'display: none;' : ''"
      >
        <div class="card-window-box">
          <!-- 车牌地区 -->
          <div class="License-plate-district" v-if="DisplayContent == '1'">
            <div class="Button">
              <p
                v-for="item in listArr"
                :key="item.id"
                class="content firm-clickable"
                @click="handelClick(item, 1)"
              >
                {{ item.name }}
              </p>
              <div class="Button-Pack-up firm-clickable" @click="handelCancel">
                <div></div>
                <p>收起</p>
              </div>
            </div>
          </div>
          <div class="License-plate" v-if="DisplayContent == '2'">
            <div class="Button">
              <p
                v-for="item in numberArr"
                :key="item.id"
                class="content firm-clickable"
                @click="handelClick(item)"
              >
                {{ item.name }}
              </p>
              <div class="Button-Pack-up firm-clickable" @click="handelCancel">
                <div></div>
                <p>收起</p>
              </div>
            </div>
            <div class="Button">
              <p
                v-for="item in letterArr2"
                :key="item.id"
                class="content firm-clickable"
                @click="handelClick(item)"
              >
                {{ item.name }}
              </p>
            </div>
            <div class="Button">
              <p
                v-for="item in letterArr1"
                :key="item.id"
                class="content firm-clickable"
                @click="handelClick(item)"
              >
                {{ item.name }}
              </p>
            </div>
          </div>

          <!-- 确认 -->
          <div class="ButtonArea">
            <p class="firm-clickable" @click="handelCancel">确 认</p>
            <!-- <p>确认</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import { postFindCarNum } from "../../../../../assets/api/indexl";
export default {
  // 组件名称

  // 组件参数 接收来自父组件的数据
  props: {
    transform: {}, // 监听此值，改变立刻清空车牌
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      listArr: [
        { name: "京", id: "1" },
        { name: "沪", id: "2" },
        { name: "津", id: "3" },
        { name: "渝", id: "4" },
        { name: "鲁", id: "5" },

        { name: "冀", id: "6" },
        { name: "鄂", id: "7" },
        { name: "黑", id: "8" },
        { name: "苏", id: "9" },
        { name: "浙", id: "10" },
        { name: "皖", id: "11" },
        { name: "闽", id: "12" },
        { name: "赣", id: "13" },
        { name: "豫", id: "14" },
        { name: "粤", id: "15" },
        { name: "桂", id: "16" },
        { name: "琼", id: "17" },
        { name: "晋", id: "18" },

        { name: "蒙", id: "19" },
        { name: "辽", id: "20" },
        { name: "吉", id: "21" },
        { name: "云", id: "22" },
        { name: "藏", id: "23" },
        { name: "陕", id: "24" },
        { name: "甘", id: "25" },
        { name: "青", id: "26" },
        { name: "宁", id: "27" },
        { name: "湘", id: "28" },
        { name: "川", id: "29" },
        { name: "贵", id: "30" },
        { name: "新", id: "31" },
      ], //车牌-地区
      letterArr2: [
        { name: "A", id: "11" },
        { name: "B", id: "12" },
        { name: "C", id: "13" },
        { name: "D", id: "14" },
        { name: "E", id: "15" },
        { name: "F", id: "16" },
        { name: "G", id: "17" },
        { name: "H", id: "18" },
        { name: "I", id: "19" },
        { name: "J", id: "20" },
        { name: "K", id: "21" },
        { name: "L", id: "22" },
        { name: "M", id: "23" },
      ],
      letterArr1: [
        { name: "N", id: "24" },
        { name: "O", id: "25" },
        { name: "P", id: "26" },
        { name: "Q", id: "27" },
        { name: "R", id: "28" },
        { name: "S", id: "29" },
        { name: "T", id: "30" },
        { name: "U", id: "31" },
        { name: "V", id: "32" },
        { name: "W", id: "33" },
        { name: "X", id: "34" },
        { name: "Y", id: "35" },
        { name: "Z", id: "36" },
      ], // 字母
      numberArr: [
        { name: "1", id: "1" },
        { name: "2", id: "2" },
        { name: "3", id: "3" },
        { name: "4", id: "4" },
        { name: "5", id: "5" },
        { name: "6", id: "6" },
        { name: "7", id: "7" },
        { name: "8", id: "8" },
        { name: "9", id: "9" },
        { name: "0", id: "10" },
      ], // 数字

      select: "",
      radio: "新", // 是否新能源
      cardShowHide: "1", // 车牌输入框的显示隐藏
      DisplayContent: "", // 1显示地区  2显示字母加数字
      AFew: 0, //当前焦点在第几个输入框
      value: [
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "新" },
      ],
      district: "", //车牌所在地
    };
  },
  // 监听
  watch: {
    transform: {
      handler(newss, old) {
        this.value = [
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "", out: "0" },
          { val: "新", out: "1" },
        ];
        const districtText = String(this.district || "");
        this.value[0].val = districtText[0] || "";
        this.value[1].val = districtText[1] || "";
      },
      immediate: false,
    },
    
     value: {
      handler(newVal, oldVal) {
        this.$emit("handelClick", this.value);
      },
      deep: true, // 开启深度监听
      immediate: true // 可选：初始化时立即触发一次
    }
  },
  // 组件初始化
  created() {
    // 获取当前城市车牌
    this.postFindCarNum();
  },
  // 组件实例挂载完毕
  mounted() {
    // 用于限制车牌框的输入，但开启时会影响别的框的输入 ！！！！！！！！
    // window.addEventListener("keydown", this.keyDown);
    // 获取要插入· 元素的位置
    var ipt = document.getElementsByTagName("input");
    var someIpt = ipt[2];
    // 创建元素
    var para = document.createElement("div");
    // 元素中的内容
    var txt = document.createTextNode("·");
    // 内容追加至新创建的元素
    para.appendChild(txt);
    // 将新创建的元素 插入指定元素后
    someIpt.parentNode.insertBefore(para, someIpt);

   
     const input = document.getElementById('noDelInput');
  // 1. 禁止键盘删除/剪切按键
  input.addEventListener('keydown', function(e) {
    const forbiddenKeys = ['Backspace', 'Delete'];
    if (forbiddenKeys.includes(e.key) || ((e.ctrlKey || e.metaKey) && e.key === 'x')) {
      e.preventDefault();
    }
  });
  // 2. 禁止剪切操作（右键菜单的剪切、快捷键剪切 都会触发这个事件）
  input.addEventListener('cut', function(e) {
    e.preventDefault();
  });
  // 3. 【可选】禁止右键菜单（彻底杜绝右键里的删除/剪切选项）
  input.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });
  },
  //销毁事件
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
  // 组件方法
  methods: {
    handler() {
     
    },
    // 最后一格失去焦点
    handelFocalPoint() {
      if (this.value[7].val == "") {
        this.value[7].val = "新";
      }
    },
    keyDown(e) {
      var evt = window.event || e;
      evt.returnValue = false; //ie 禁止键盘输入
      evt.preventDefault(); //fire fox 禁止键盘输入
    },
    // 获取车牌 接口
    postFindCarNum() {
      postFindCarNum().then((res) => {
        if (res.code == 0) {
          this.district = res.data || "";
          const districtText = String(this.district);
          this.value[0].val = districtText[0] || "";
          this.value[1].val = districtText[1] || "";
          this.$emit("postFindCarNum");
        }
      });
    },
    //取消按钮
    handelCancel() {
      this.cardShowHide = "1";
      this.DisplayContent = "1";
    },
    // input获取焦点事件
    handelOnfocus(item) {
     
    },
    // 键盘点击事件
    handelClick(item, num) {
      document.getElementsByTagName("input")[this.AFew + 1].focus();
      if (this.AFew == 7) {
        this.cardShowHide = "1";
      }
      this.select = item.id;
      if (num) {
        this.cardShowHide = "2";
        this.DisplayContent = "2";
        this.value[0].val = item.name;
        this.AFew++;
      } else {
        if (this.AFew < 8) {
          this.value[this.AFew].val = item.name;
          this.AFew++;
        }
      }
      this.$emit("handelClick", this.value);
    },
    // 点击车牌框
    handelReveal(num) {
      // this.value[num].val = "";
      if (num != 8) {
        this.AFew = num;
      }
      if (num == 0) {
        this.cardShowHide = "2";
        this.DisplayContent = "1";
      } else if (num != 0) {
        this.cardShowHide = "2";
        this.DisplayContent = "2";
      }
    },
  },
};
</script>

<style scoped lang="less">
.body-box {
  width: 100%;
  height: 100%;
  display: flex;
  // 车牌输入框
  .card {
    display: flex;
    position: relative;
    .card-window {
      width: 640px;
      min-height: 250px;
      position: absolute;
      top: 40px;
      background: #ffffff;
      box-shadow: 0px 10px 20px 0px rgba(125, 125, 125, 0.5);
      border-radius: 15px;
      z-index: 999;
      display: flex;
      .card-window-box {
        padding: 30px 20px 0px 20px;
        width: 640px;
        min-height: 250px;
        margin: auto;
        .License-plate-district {
          width: 100%;
          height: 145px;
          margin-top: 10px;
          .Button {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            position: relative;
          }
        }
        .License-plate {
          width: 100%;
          margin-top: 10px;
          .Button {
            width: 100%;
            height: 35px;
            margin-bottom: 20px;
            display: flex;
            position: relative;
          }
        }
        .Button-Pack-up {
          width: 50px;
          height: 15px;
          line-height: 15px;
          position: absolute;
          right: 0px;
          top: -20px;
          display: flex;
          div {
            width: 15px;
            height: 8px;
            margin-top: 3px;
            background-image: url("../../../../../assets/imgs/arrow-drop-down-fill@3x.svg");
            background-size: 100% 100%;
          }
          p {
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #409eff ;
            text-align: center;
            margin-left: 5px;
          }
        }
        // 车牌
        .text-box {
          width: 97%;
          margin: 0 auto;
          height: 20px;
          line-height: 20px;
          display: flex;
          margin-top: 5px;
          .text {
            width: 20px;
            height: 20px;
            text-align: center;
            margin-left: 5px;
            border: 1px solid gray;
          }
        }
        // 选择区
        // 未选择样式
        .content:active {
          color: #4095e5;
          background-color: rgba(97, 144, 232, 0.27);
        }
        .content:hover {
          color: #4095e5;
          background-color: rgba(97, 144, 232, 0.27);
        }
        .content {
          width: 34px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          font-size: 14px;
          background: #ffffff;
          border: 1px solid #409eff ;
          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
        }
        // 选中样式

        // 是否新能源
        .New-energy {
          width: 95%;
          height: 20px;
          margin: 0 auto;
          margin-top: 5px;
          margin-bottom: 5px;
          /deep/span {
            color: #101010 !important;
            font-size: 14px;
            font-weight: 400;
          }
        }
        // 按钮完成/删除/取消
        .ButtonArea {
          width: 100%;
          height: 40px;
          line-height: 40px;
          margin-top: 10px;
          margin-bottom: 10px;
          display: flex;
          justify-content: flex-end;
          font-size: 14px;
          p {
            width: 120px;
            height: 40px;
            text-align: center;
            background: #409eff ;
            border-radius: 5px;
            font-size: 16px;
            color: #ffffff;
          }
          p:nth-child(1) {
            background: #409eff ;
            border-radius: 5px;
          }
          p:nth-child(2) {
            border: 1px solid gray;
            background-color: #4095e5;
            color: #ffffff;
          }
        }
      }
    }

    input {
      width: 33px;
      height: 33px;
      background: #ffffff;
      border: 1px solid #409eff ;
      border-radius: 5px;
      margin-left: 5px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #409eff ;
      outline: none;
    }
    input:nth-child(1) {
      margin-left: 0px;
    }
  }
}
</style>
